export default "__VITE_ASSET__IQggsu$0__"